import DownloadIcon from "@mui/icons-material/GetApp";
import {
  Box,
  Grid,
  Link,
  LinearProgress,
  List,
  ListItem,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import * as React from "react";
import { useEffect, useState } from "react";
import { Button, useRefresh } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSubmit from "../../unit/CustomButtonSubmit";
import CustomDateTextInput from "../../unit/CustomDateTextInput";
import CustomDialogTitle from "../../unit/CustomDialogTitle";
import DownloadFileDirect from "../../unit/DownloadFileDirect";
import DownloadFileGenerated from "../../unit/DownloadFileGenerated";
import HeaderLabelTitle from "../../unit/HeaderLabelTitle";
import CustomControlEditTextField from "../../unit/forms/CustomControlEditTextField";
import CustomControlMoneyEditTextField from "../../unit/forms/CustomControlMoneyEditTextField";
import CustomEditControlSelect from "../../unit/forms/CustomEditControlSelect";
import CustomSelect from "../../unit/forms/CustomSelect";
import useNotify from "../../unit/useNotify";
import DialogApplicationBaseInfo from "../DialogApplicationBaseInfo";
import CustomToNotifyDepositDialog from "./CustomToNotifyDepositDialog";
import CustomToNotifyDisbursementDialog from "./CustomToNotifyDisbursementDialog";
import { CircularProgress } from "@mui/material";
import { useDownloadFile } from "../../unit/useDownloadFile";
import downloadFileFun from "../../unit/DownloadFileFun";
import CustomApplicationDialogTitle from "./CustomApplicationDialogTitle";
import CustomButtonSave from "../../unit/CustomButtonSave";
import { error } from "console";
import DownloadFieldLink from "../../unit/DownloadFieldLink";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function CustomToNotify2PreApprovedFormDialog({ ...props }) {
  const PREVIEW_STEPS = {
    save: "Saving data...",
    generate: "Generating file on server...",
    download: "Downloading to browser...",
  };
  const [saveGeneralInfoTitle, setSaveGeneralInfoTitle] = useState("Save");
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const [open, setOpen] = React.useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [disabledTab, setDisabledTab] = useState(false);
  const { appId, record } = props;
  const cbfun = props?.cb;

  // 用于同步props.record变化到state，保证保存后切换Tab能看到最新数据
  useEffect(() => {
    if (!open) return;
    setLateFee(
      record?.sSaved === "YES"
        ? record?.loan_saved_iLateFee
        : record?.defaultLateFee
    );
    setGracePeriodDay(
      record?.sSaved === "YES"
        ? record?.loan_saved_iGracePeriod
        : record?.iGracePeriod
    );
    setOriginationFeeAmount(
      record?.sSaved === "YES"
        ? record?.loan_saved_iOriginationFee
        : record?.origination_fee_amount || 0
    );
    setPaymentCount(record?.loan?.paymentsNumber);
    setNoteDate(record?.dNoteDate?.substring(0, 10));
    // setFirstPaymentDate(dayjs().format("YYYY-MM-DD"));
    setPaymentFrequency(record?.sPaymentFrequency);
    setOrigination_fee_type(record?.origination_fee_type || "");
    let loanInterestRate = record?.loan?.interestRate;
    if (loanInterestRate == undefined || loanInterestRate == null) {
      loanInterestRate = "";
    }
    if (loanInterestRate == "0.00" || loanInterestRate == null) {
      loanInterestRate = 0;
    }
    setInterestRate(
      record?.sSaved === "YES" ? record?.loan_saved_iRate : loanInterestRate
    );
    setTerms(parseInt(record?.termReview));
  }, [record, open]);

  const loan_saved = record?.sSaved;
  const loan_saved_iOriginationFee = record?.loan_saved_iOriginationFee; //ok
  const loan_saved_origination_fee_type = record?.origination_fee_type; //ok
  const loan_saved_iRate = record?.loan_saved_iRate; //ok
  const loan_saved_iGracePeriod = record?.loan_saved_iGracePeriod; //ok
  const loan_saved_iLateFee = record?.loan_saved_iLateFee; //ok
  let loan_saved_loanamount = record?.iLoanAmount;
  if (loan_saved_origination_fee_type == "Deduct from Funded Amount") {
    loan_saved_loanamount = record?.iLoanAmount;
  } else {
    loan_saved_loanamount = record?.iFundAmount;
  }

  const termsDefineApprove = record?.termsDefine?.notify_approve;
  const [lateFee, setLateFee] = useState(
    loan_saved == "YES" ? loan_saved_iLateFee : record?.defaultLateFee
  );
  const [value, setValue] = React.useState(0);
  const [isSubmit, setIsSubmit] = useState(false);
  const [checkCal, setCheckCal] = useState(true);
  const [previewTitle, setPreviewTitle] = useState("Preview");
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [previewProgress, setPreviewProgress] = useState(0);
  const [previewProgressLabel, setPreviewProgressLabel] = useState("");
  const previewProgressRef = React.useRef(0);
  const generateProgressTimerRef = React.useRef<ReturnType<
    typeof setInterval
  > | null>(null);
  const downloadStartProgressRef = React.useRef(25);
  const [submitTitle, setSubmitTitle] = React.useState("Submit");
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [filePath, setFilePath] = React.useState("");
  const [generateFileInfo, setGenerateFileInfo] = useState<{
    filename: string;
    filetype: string;
    filekey: string;
    filelink?: string;
    docId: number;
  } | null>(null);
  const [gracePeriodDay, setGracePeriodDay] = useState(
    loan_saved == "YES" ? loan_saved_iGracePeriod : record?.iGracePeriod
  );
  const [maturityDate, setMaturityDate] = useState(record?.dMaturityDate);
  const [paymentCount, setPaymentCount] = useState(
    record?.loan?.paymentsNumber
  );
  const [noteDate, setNoteDate] = useState(record?.dNoteDate?.substring(0, 10));
  const [firstPaymentDate, setFirstPaymentDate] = useState(
    record?.dFirstPaymentDate?.substring(0, 10) || dayjs().format("YYYY-MM-DD")
  );
  const [paymentFrequency, setPaymentFrequency] = useState(
    record?.sPaymentFrequency
  );
  const refresh = useRefresh();
  useEffect(() => {
    previewProgressRef.current = previewProgress;
  }, [previewProgress]);

  const updatePreviewProgress = (progress: number, label: string) => {
    setPreviewProgress(progress);
    setPreviewProgressLabel(label);
  };

  const clearGenerateProgressTimer = () => {
    if (generateProgressTimerRef.current) {
      clearInterval(generateProgressTimerRef.current);
      generateProgressTimerRef.current = null;
    }
  };

  const startGenerateProgressTimer = () => {
    clearGenerateProgressTimer();
    generateProgressTimerRef.current = setInterval(() => {
      setPreviewProgress((prev) => {
        if (prev >= 84) {
          return prev;
        }

        const step = prev < 18 ? 0.8 : prev < 40 ? 1.2 : prev < 64 ? 0.9 : 0.45;

        return Math.min(84, Number((prev + step).toFixed(2)));
      });
    }, 500);
  };

  const resetPreviewLoadingState = () => {
    clearGenerateProgressTimer();
    setPreviewTitle("Preview");
    setIsPreviewLoading(false);
    setPreviewProgress(0);
    setPreviewProgressLabel("");
    downloadStartProgressRef.current = 25;
  };

  const resetSubmitState = () => {
    setSubmitTitle("Submit");
    setIsSubmitting(false);
  };

  useEffect(() => {
    return () => {
      clearGenerateProgressTimer();
    };
  }, []);
  let loanInterestRate = record?.loan?.interestRate;
  if (loanInterestRate == undefined || loanInterestRate == null) {
    loanInterestRate = "";
  }
  if (loanInterestRate == "0.00" || loanInterestRate == null) {
    loanInterestRate = 0;
  }
  const [interestRate, setInterestRate] = useState(
    loan_saved == "YES" ? loan_saved_iRate : loanInterestRate
  );
  const [terms, setTerms] = useState(parseInt(record?.termReview));
  const [origination_fee_type, setOrigination_fee_type] = useState(
    record?.origination_fee_type || ""
  );
  const [submitFormData, setSubmitFormData] = useState({});
  // 新增：originationFeeAmount state
  // const [originationFeeAmount, setOriginationFeeAmount] = useState(
  //   record?.origination_fee_amount || 0
  // );
  const [originationFeeAmount, setOriginationFeeAmount] = useState(
    loan_saved == "YES"
      ? loan_saved_iOriginationFee
      : record?.origination_fee_amount || 0
  );
  let defaultOriginationFeeType = record?.origination_fee_type;
  if (
    record?.origination_fee_amount == 0 ||
    record?.origination_fee_amount == "0" ||
    record?.origination_fee_amount == "0.00"
  ) {
    defaultOriginationFeeType = "";
  }
  const [originationFeeTypeRequired, setOriginationFeeTypeRequired] = useState(
    loan_saved == "YES"
      ? loan_saved_origination_fee_type
      : defaultOriginationFeeType
  );
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    // loanamount变化时，自动计算originationFeeAmount
    if (name === "loanamount") {
      let newOriginAmount = 0;
      if (
        value !== "" &&
        value !== null &&
        value !== undefined &&
        record?.iOriginationFee
      ) {
        if (record?.sOriginationFeeUnit === "Percentage") {
          newOriginAmount =
            (parseFloat(value.replace(/,/g, "")) * record.iOriginationFee) /
            100;
        } else if (record?.sOriginationFeeUnit === "Fixed") {
          newOriginAmount = record.iOriginationFee;
        }
      }
      setOriginationFeeAmount(newOriginAmount);
      setSubmitFormData({
        ...submitFormData,
        [name]: value,
        origination_fee_amount: newOriginAmount,
      });
      return;
    }
    setSubmitFormData({
      ...submitFormData,
      [name]: value,
    });
  };

  // 新增保存方法，参考Approved
  const handleSaveInfoPreApprove = async ({ event, appId }) => {
    setDisabledTab(true);

    setSaveGeneralInfoTitle("loading");
    let newSubFormData = {
      loannum: (
        document.querySelector(
          `#dialog-application-tonotify-pre-approve-${appId} [name="loannum"]`
        ) as HTMLInputElement
      )?.value,
      loanamount: (
        document.querySelector(
          `#dialog-application-tonotify-pre-approve-${appId} [name="loanamount"]`
        ) as HTMLInputElement
      )?.value.replace(/,/g, ""),
      interest_rate: (
        document.querySelector(
          `#dialog-application-tonotify-pre-approve-${appId} [name="interest_rate"]`
        ) as HTMLInputElement
      )?.value,
      terms: (
        document.querySelector(
          `#dialog-application-tonotify-pre-approve-${appId} [name="terms"]`
        ) as HTMLInputElement
      )?.value,
      note_date: (
        document.querySelector(
          `#dialog-application-tonotify-pre-approve-${appId} [name="note_date"]`
        ) as HTMLInputElement
      )?.value,
      first_payment_date: (
        document.querySelector(
          `#dialog-application-tonotify-pre-approve-${appId} [name="first_payment_date"]`
        ) as HTMLInputElement
      )?.value,
      payment_frequency: (
        document.querySelector(
          `#dialog-application-tonotify-pre-approve-${appId} [name="payment_frequency"]`
        ) as HTMLInputElement
      )?.value,
      number_payments: (
        document.querySelector(
          `#dialog-application-tonotify-pre-approve-${appId} [name="number_payments"]`
        ) as HTMLInputElement
      )?.value,
      maturity_date: (
        document.querySelector(
          `#dialog-application-tonotify-pre-approve-${appId} [name="maturity_date"]`
        ) as HTMLInputElement
      )?.value,
      origination_fee_amount: (
        document.querySelector(
          `#dialog-application-tonotify-pre-approve-${appId} [name="origination_fee_amount"]`
        ) as HTMLInputElement
      )?.value.replace(/,/g, ""),
      origination_fee_type: (
        document.querySelector(
          `#dialog-application-tonotify-pre-approve-${appId} [name="origination_fee_type"]`
        ) as HTMLInputElement
      )?.value,
      grace_period: (
        document.querySelector(
          `#dialog-application-tonotify-pre-approve-${appId} [name="grace_period"]`
        ) as HTMLInputElement
      )?.value,
      late_fee: (
        document.querySelector(
          `#dialog-application-tonotify-pre-approve-${appId} [name="late_fee"]`
        ) as HTMLInputElement
      )?.value,
    };
    // 字段校验
    const requiredFields = [
      { key: "loannum", label: "Loan Number" },
      { key: "loanamount", label: "Loan Amount" },
      { key: "interest_rate", label: "Interest Rate" },
      { key: "terms", label: "Term (Months)" },
      { key: "note_date", label: "Note Date" },
      { key: "first_payment_date", label: "First Payment Date" },
      { key: "payment_frequency", label: "Payment Frequency" },
      { key: "number_payments", label: "Number Of Payments" },
      { key: "maturity_date", label: "Maturity Date" },
    ];
    let missingFields = [];
    for (const field of requiredFields) {
      if (
        newSubFormData[field.key] === "" ||
        newSubFormData[field.key] == null ||
        newSubFormData[field.key] == undefined
      ) {
        missingFields.push(field.label);
      }
    }
    // origination_fee_amount 有值时，origination_fee_type 必填
    if (
      newSubFormData.origination_fee_amount !== "" &&
      newSubFormData.origination_fee_amount !== "0.00" &&
      newSubFormData.origination_fee_amount !== "0" &&
      newSubFormData.origination_fee_amount != null &&
      newSubFormData.origination_fee_amount != undefined
    ) {
      if (
        newSubFormData.origination_fee_type === "" ||
        newSubFormData.origination_fee_type == null ||
        newSubFormData.origination_fee_type == undefined
      ) {
        missingFields.push("Origination Fee Type");
      }
    }
    // 额外校验：First Payment Date 必须大于 Note Date
    if (
      newSubFormData.first_payment_date &&
      newSubFormData.note_date &&
      dayjs(newSubFormData.first_payment_date).isBefore(
        dayjs(newSubFormData.note_date),
        "day"
      )
    ) {
      missingFields.push("First Payment Date must be greater than Note Date");
    }
    if (missingFields.length > 0) {
      errorNotify("Please fill required fields: " + missingFields.join(", "));
      setSaveGeneralInfoTitle("Save");
      return false;
    }
    const reqUrl = `applications/actions/saveappinfo`;
    const response = await sendRequest(reqUrl, {
      id: appId,
      data: newSubFormData,
    });
    if (response && (response.status == "200" || response.code == "200")) {
      successNotify("Data saved successfully");
      refresh();
      setSaveGeneralInfoTitle("Save");

      //延迟2秒
      setTimeout(() => {
        setDisabledTab(false);
      }, 2000);
    } else {
      errorNotify(response?.message || "Data not saved!");
      setSaveGeneralInfoTitle("Save");
      //延迟2秒
      setTimeout(() => {
        setDisabledTab(false);
      }, 2000);
    }
  };
  const handleInputCustomChange = (
    p0: string,
    {
      name,
      value,
    }: {
      name: string;
      value: any;
    }
  ) => {
    setSubmitFormData({
      ...submitFormData,
      [name]: value,
    });
  };

  useEffect(() => {
    calMatDate();
  }, [noteDate, firstPaymentDate, paymentFrequency, interestRate, terms]);

  // useEffect(() => {
  //   updateLateFeeAndGracePeriod({ record });
  // }, [paymentFrequency]);

  const [init, setInit] = useState(true);
  useEffect(() => {
    if (init && loan_saved === "YES") {
      setInit(false);
      return;
    }
    updateLateFeeAndGracePeriod({ record });
    setInit(false);
  }, [paymentFrequency]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const handleChangePaymentFrequency = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const paymentFrequency = event.target.value;
  };
  const handleClickOpen = () => {
    setOpen(true);
    setFilePath("");
    setGenerateFileInfo(null);
  };

  const handleClose = () => {
    setOpen(false);
    setFilePath("");
    setGenerateFileInfo(null);
    resetSubmitState();
    resetPreviewLoadingState();
    refresh();
  };

  const formatRate = (num) => {
    if (num == "" || num == null || num == 0) {
      return "0.00%";
    } else {
      return num + "%";
    }
  };

  const defautRateOptionList: { label: string; value: any }[] = [];
  defautRateOptionList.push({ label: "Select", value: "" });
  if (record.rateData) {
    for (let i = 0; i < Object.keys(record.rateData).length; i++) {
      defautRateOptionList.push({
        label: formatRate(record.rateData[i]),
        value: record.rateData[i] == undefined ? 0 : record.rateData[i],
      });
    }
  }
  const defautTermsList: { label: any; value: any }[] = [];
  defautTermsList.push({ label: "Select", value: 0 });
  if (record.termsData) {
    for (let i = 0; i < record.termsData.length; i++) {
      defautTermsList.push({
        label: record.termsData[i],
        value: parseInt(record.termsData[i]),
      });
    }
  }

  const defautPaymentFreqList: { label: any; value: any }[] = [];
  if (record.paymentFrequencyData) {
    for (let i = 0; i < record.paymentFrequencyData.length; i++) {
      defautPaymentFreqList.push({
        label: record.paymentFrequencyData[i].name,
        value: record.paymentFrequencyData[i].bbkey,
      });
    }
  }

  const defautOriginationFeeTypeList: { label: any; value: any }[] = [];
  defautOriginationFeeTypeList.push({ label: "Select", value: "" });
  defautOriginationFeeTypeList.push({
    label: "Add to Loan Amount",
    value: "Add to Loan Amount",
  });
  defautOriginationFeeTypeList.push({
    label: "Deduct from Funded Amount",
    value: "Deduct from Funded Amount",
  });

  const defautAccountTypeList: { label: any; value: any }[] = [];
  defautAccountTypeList.push({ label: "Select", value: "" });
  defautAccountTypeList.push({ label: "Checking", value: "Checking" });
  defautAccountTypeList.push({ label: "Savings", value: "Savings" });

  const calMatDate = async () => {
    let checkCalFun = true;

    setPreviewTitle("Preview");

    if (
      noteDate == "" ||
      noteDate == null ||
      noteDate == undefined ||
      noteDate == "YYYY-MM-DD" ||
      noteDate == "0000-00-00"
    ) {
      checkCalFun = false;
    }
    // console.log(
    //   "checkCalFun notedate",
    //   checkCalFun ? "true" : "false",
    //   noteDate
    // );
    if (
      firstPaymentDate == "" ||
      firstPaymentDate == null ||
      firstPaymentDate == undefined ||
      firstPaymentDate == "YYYY-MM-DD" ||
      firstPaymentDate == "0000-00-00"
    ) {
      checkCalFun = false;
    }
    // console.log(
    //   "checkCalFun firstpaymentdate",
    //   checkCalFun ? "true" : "false",
    //   firstPaymentDate
    // );
    if (dayjs(firstPaymentDate).isBefore(dayjs(), "day")) {
      // errorNotify("First Payment Date must be greater than today");
      checkCalFun = false;
    }
    if (dayjs(firstPaymentDate).isBefore(dayjs(noteDate), "day")) {
      // errorNotify("First Payment Date must be greater than Note Date");
      checkCalFun = false;
    }
    // console.log(
    //   "checkCalFun",
    //   checkCalFun ? "true" : "false",
    //   noteDate,
    //   firstPaymentDate
    // );
    if (
      paymentFrequency == "" ||
      paymentFrequency == null ||
      paymentFrequency == undefined
    ) {
      checkCalFun = false;
    }
    // console.log(
    //   "checkCalFun paymentFrequency",
    //   checkCalFun ? "true" : "false",
    //   paymentFrequency
    // );
    // if (
    //   interestRate == "" ||
    //   interestRate == null ||
    //   interestRate == undefined
    // ) {
    //   checkCalFun = false;
    // }
    // console.log(
    //   "checkCalFun interestRate",
    //   checkCalFun ? "true" : "false",
    //   interestRate
    // );
    if (terms == "" || terms == null || terms == undefined) {
      checkCalFun = false;
    }
    // console.log("checkCalFun terms", checkCalFun ? "true" : "false", terms);
    const formJson = {
      amouant: record.amountSubmit,
      note_date: noteDate,
      iterm: terms,
      payment_frequency: paymentFrequency,
      rate: interestRate,
      first_payment_date: firstPaymentDate,
    };

    if (checkCalFun == false) {
      return false;
    } else {
      const reqUrl = `calculate/getmaturitydate`;
      const response = await sendRequest(reqUrl, {
        id: appId,
        data: formJson,
      });
      if (response && response.status == "200") {
        setMaturityDate(
          dayjs(response.data.maturity_date).format("YYYY-MM-DD")
        );
        setPaymentCount(response.data.payment_count);
        setIsSubmit(true);
      } else {
        errorNotify("Error in calculating maturity date");
      }
    }
  };

  const updateLateFeeAndGracePeriod = ({ ...props }) => {
    const record = props.record;
    let max_latefee = record?.lateFeeData?.reduce(function (
      prev: any,
      current: any
    ) {
      return prev.lateFee > current.lateFee ? prev : current;
    });
    let adjust_latefee = record?.lateFeeAdjust;
    let max_grace_period = record?.gracePeriodData?.reduce(function (
      prev: any,
      current: any
    ) {
      return prev.gracePeriod > current.gracePeriod ? prev : current;
    });

    let adjust_grace_period = record?.gracePeriodAdjust;
    let latefee = max_latefee;
    let graceperiod = max_grace_period;

    if (
      paymentFrequency == "Monthly" ||
      paymentFrequency == "Month End Payment" ||
      paymentFrequency == "Single Repayment"
    ) {
      latefee = max_latefee;
      graceperiod = 16;
    } else if (paymentFrequency == "Semimonthly") {
      latefee = toDecimal(max_latefee / 2, 2);
      graceperiod = 8;
    } else if (paymentFrequency == "Weekly") {
      latefee = toDecimal(max_latefee / 4, 2);
      graceperiod = 6;
    } else if (paymentFrequency == "Bi-Weekly") {
      latefee = toDecimal(max_latefee / 2, 2);
      graceperiod = 8;
    }

    if (adjust_latefee == "No" || adjust_latefee == "") {
      latefee = max_latefee;
    }
    if (adjust_grace_period == "No" || adjust_grace_period == "") {
      graceperiod = record.iGracePeriod
        ? record.iGracePeriod
        : max_grace_period;
    }

    setGracePeriodDay(graceperiod);
    // console.log("latefee ====>", latefee);
    setLateFee(latefee);
  };

  function toDecimal(x: any, y: any) {
    var f = parseFloat(x);
    if (isNaN(f)) {
      return;
    }
    f = Math.round(x * 100) / 100;
    return f;
  }
  const handlePreviewPreApprove = async ({ ...props }) => {
    if (isSubmitting) {
      return false;
    }

    const { appId, event } = props;
    const { downloadFileGenerated } = useDownloadFile();
    setIsPreviewLoading(true);
    setPreviewTitle("loading");
    updatePreviewProgress(8, PREVIEW_STEPS.save);
    let newSubFormData = {
      loannum: (
        document.querySelector(
          `#dialog-application-tonotify-pre-approve-${appId} [name="loannum"]`
        ) as HTMLInputElement
      )?.value,
      loanamount: (
        document.querySelector(
          `#dialog-application-tonotify-pre-approve-${appId} [name="loanamount"]`
        ) as HTMLInputElement
      )?.value.replace(/,/g, ""),
      interest_rate: (
        document.querySelector(
          `#dialog-application-tonotify-pre-approve-${appId} [name="interest_rate"]`
        ) as HTMLInputElement
      )?.value,
      terms: (
        document.querySelector(
          `#dialog-application-tonotify-pre-approve-${appId} [name="terms"]`
        ) as HTMLInputElement
      )?.value,
      note_date: (
        document.querySelector(
          `#dialog-application-tonotify-pre-approve-${appId} [name="note_date"]`
        ) as HTMLInputElement
      )?.value,
      first_payment_date: (
        document.querySelector(
          `#dialog-application-tonotify-pre-approve-${appId} [name="first_payment_date"]`
        ) as HTMLInputElement
      )?.value,
      payment_frequency: (
        document.querySelector(
          `#dialog-application-tonotify-pre-approve-${appId} [name="payment_frequency"]`
        ) as HTMLInputElement
      )?.value,
      number_payments: (
        document.querySelector(
          `#dialog-application-tonotify-pre-approve-${appId} [name="number_payments"]`
        ) as HTMLInputElement
      )?.value,
      maturity_date: (
        document.querySelector(
          `#dialog-application-tonotify-pre-approve-${appId} [name="maturity_date"]`
        ) as HTMLInputElement
      )?.value,
      origination_fee_amount: (
        document.querySelector(
          `#dialog-application-tonotify-pre-approve-${appId} [name="origination_fee_amount"]`
        ) as HTMLInputElement
      )?.value.replace(/,/g, ""),
      origination_fee_type: (
        document.querySelector(
          `#dialog-application-tonotify-pre-approve-${appId} [name="origination_fee_type"]`
        ) as HTMLInputElement
      )?.value,
      grace_period: (
        document.querySelector(
          `#dialog-application-tonotify-pre-approve-${appId} [name="grace_period"]`
        ) as HTMLInputElement
      )?.value,
      late_fee: (
        document.querySelector(
          `#dialog-application-tonotify-pre-approve-${appId} [name="late_fee"]`
        ) as HTMLInputElement
      )?.value,
    };
    // 字段校验
    const requiredFields = [
      { key: "loannum", label: "Loan Number" },
      { key: "loanamount", label: "Loan Amount" },
      { key: "interest_rate", label: "Interest Rate" },
      { key: "terms", label: "Term (Months)" },
      { key: "note_date", label: "Note Date" },
      { key: "first_payment_date", label: "First Payment Date" },
      { key: "payment_frequency", label: "Payment Frequency" },
      { key: "number_payments", label: "Number Of Payments" },
      { key: "maturity_date", label: "Maturity Date" },
    ];
    let missingFields = [];
    for (const field of requiredFields) {
      if (
        newSubFormData[field.key] === "" ||
        newSubFormData[field.key] == null ||
        newSubFormData[field.key] == undefined
      ) {
        missingFields.push(field.label);
      }
    }
    // origination_fee_amount 有值时，origination_fee_type 必填
    if (
      newSubFormData.origination_fee_amount !== "" &&
      newSubFormData.origination_fee_amount !== "0.00" &&
      newSubFormData.origination_fee_amount !== "0" &&
      newSubFormData.origination_fee_amount != null &&
      newSubFormData.origination_fee_amount != undefined
    ) {
      if (
        newSubFormData.origination_fee_type === "" ||
        newSubFormData.origination_fee_type == null ||
        newSubFormData.origination_fee_type == undefined
      ) {
        missingFields.push("Origination Fee Type");
      }
    }
    // 额外校验：First Payment Date 必须大于 Note Date
    if (
      newSubFormData.first_payment_date &&
      newSubFormData.note_date &&
      dayjs(newSubFormData.first_payment_date).isBefore(
        dayjs(newSubFormData.note_date),
        "day"
      )
    ) {
      missingFields.push("First Payment Date must be greater than Note Date");
    }
    if (missingFields.length > 0) {
      errorNotify("Please fill required fields: " + missingFields.join(", "));
      resetPreviewLoadingState();
      return false;
    }
    const reqUrl = `applications/actions/saveappinfo`;
    const response = await sendRequest(reqUrl, {
      id: appId,
      data: newSubFormData,
    });

    if (response && (response.status == "200" || response.code == "200")) {
      const message = response?.message;
      const responseCode = response?.code;
      if (message == "Lost Template File") {
        resetPreviewLoadingState();
        errorNotify("Missing Template File");
      } else if (message == "event not exist") {
        resetPreviewLoadingState();
        errorNotify("review event not exist");
      } else {
        updatePreviewProgress(18, PREVIEW_STEPS.generate);
        startGenerateProgressTimer();
        await downloadFileFun(
          appId,
          "preapprove_preview.pdf",
          "execute2preapprove_preview",
          "",
          {
            onError: (message: string) => {
              errorNotify(message);
            },
            onStageChange: (stage) => {
              if (stage === "generating") {
                updatePreviewProgress(
                  Math.max(previewProgressRef.current, 18),
                  PREVIEW_STEPS.generate
                );
                startGenerateProgressTimer();
              }

              if (stage === "downloading") {
                clearGenerateProgressTimer();
                downloadStartProgressRef.current =
                  previewProgressRef.current > 18
                    ? previewProgressRef.current
                    : 18;
                setPreviewProgressLabel(PREVIEW_STEPS.download);
              }
            },
            onDownloadProgress: (percent) => {
              if (typeof percent !== "number") {
                setPreviewProgress((prev) => Math.min(99, prev + 0.2));
                return;
              }

              const base = downloadStartProgressRef.current;
              const mapped = base + (percent / 100) * (100 - base);

              setPreviewProgress((prev) =>
                Math.max(prev, Math.min(100, Math.round(mapped)))
              );
            },
          }
        );
        clearGenerateProgressTimer();
        setPreviewProgress(100);
        await new Promise((resolve) => setTimeout(resolve, 600));
        refresh();
        resetPreviewLoadingState();
      }
    } else {
      errorNotify(response?.message || "Data not saved!");
      resetPreviewLoadingState();
    }
  };

  const handleApproveSend = async ({ ...props }) => {
    if (isSubmitting || isPreviewLoading) {
      return;
    }

    let { appId } = props;
    const reqUrl = `applications/actions/notify/toPreApproved`;
    const response = await sendRequest(reqUrl, {
      id: appId,
      data: { option: "pre-approve" },
    });
    if (response && (response.status == "200" || response.code == "200")) {
      successNotify("Data saved successfully");
      handleClose();
      if (cbfun) {
        cbfun("Pre-Approved");
      }
    }
  };

  const [readOnly, setReadOnly] = useState(true);
  const [showPreApproveDownloadIcon, setShowPreApproveDownloadIcon] =
    React.useState(false);
  const handleDownloadPreApprovePDF = async () => {
    setShowPreApproveDownloadIcon(true);
    await downloadFileFun(appId, appId + "-preapprove", "preapprove", filePath);
    setTimeout(() => {
      setShowPreApproveDownloadIcon(false);
    }, 1000);
  };
  return (
    <React.Fragment>
      <Button
        id={"btn-application-tonotify-pre-approve-" + appId}
        label="Pre-Approve"
        variant="contained"
        size="medium"
        color="success"
        sx={{ marginLeft: "10px", width: "150px" }}
        onClick={handleClickOpen}
      />
      <Dialog
        id={"dialog-application-tonotify-pre-approve-" + appId}
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="lg"
        PaperProps={{
          component: "form",
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            if (isSubmitting || isPreviewLoading) {
              return false;
            }

            let checkCal = await calMatDate();
            if (checkCal == false) {
              errorNotify("Please fill all required fields");
              return false;
            } else {
              setIsSubmitting(true);
              setSubmitTitle("loading");
              let newSubFormData = {
                loannum: (
                  document.querySelector(
                    `#dialog-application-tonotify-pre-approve-${appId} [name="loannum"]`
                  ) as HTMLInputElement
                )?.value,
                loanamount: (
                  document.querySelector(
                    `#dialog-application-tonotify-pre-approve-${appId} [name="loanamount"]`
                  ) as HTMLInputElement
                )?.value.replace(/,/g, ""),
                interest_rate: (
                  document.querySelector(
                    `#dialog-application-tonotify-pre-approve-${appId} [name="interest_rate"]`
                  ) as HTMLInputElement
                )?.value,
                terms: (
                  document.querySelector(
                    `#dialog-application-tonotify-pre-approve-${appId} [name="terms"]`
                  ) as HTMLInputElement
                )?.value,
                note_date: (
                  document.querySelector(
                    `#dialog-application-tonotify-pre-approve-${appId} [name="note_date"]`
                  ) as HTMLInputElement
                )?.value,
                first_payment_date: (
                  document.querySelector(
                    `#dialog-application-tonotify-pre-approve-${appId} [name="first_payment_date"]`
                  ) as HTMLInputElement
                )?.value,
                payment_frequency: (
                  document.querySelector(
                    `#dialog-application-tonotify-pre-approve-${appId} [name="payment_frequency"]`
                  ) as HTMLInputElement
                )?.value,
                number_payments: (
                  document.querySelector(
                    `#dialog-application-tonotify-pre-approve-${appId} [name="number_payments"]`
                  ) as HTMLInputElement
                )?.value,
                maturity_date: (
                  document.querySelector(
                    `#dialog-application-tonotify-pre-approve-${appId} [name="maturity_date"]`
                  ) as HTMLInputElement
                )?.value,
                origination_fee_amount: (
                  document.querySelector(
                    `#dialog-application-tonotify-pre-approve-${appId} [name="origination_fee_amount"]`
                  ) as HTMLInputElement
                )?.value.replace(/,/g, ""),
                origination_fee_type: (
                  document.querySelector(
                    `#dialog-application-tonotify-pre-approve-${appId} [name="origination_fee_type"]`
                  ) as HTMLInputElement
                )?.value,
                grace_period: (
                  document.querySelector(
                    `#dialog-application-tonotify-pre-approve-${appId} [name="grace_period"]`
                  ) as HTMLInputElement
                )?.value,
                late_fee: (
                  document.querySelector(
                    `#dialog-application-tonotify-pre-approve-${appId} [name="late_fee"]`
                  ) as HTMLInputElement
                )?.value,
              };
              const reqUrl = `applications/actions/saveappinfo`;
              const response = await sendRequest(reqUrl, {
                id: appId,
                data: newSubFormData,
              });
              if (
                response &&
                (response.status == "200" || response.code == "200")
              ) {
                successNotify("Data saved successfully");
                const message = response.message;
                const responseCode = response.code;
                if (message == "Lost Template File") {
                  errorNotify("Missing Template File");
                } else if (message == "event not exist") {
                  errorNotify("review event not exist");
                } else {
                  successNotify("Data saved successfully");
                  const filetype = "preapprove_preview.pdf";
                  const filekey = "execute2preapprove_preview";
                  const generalFileUrl =
                    "applications/pdfs/fillForm/generatedPdf";
                  const formData = new FormData();
                  const formJson = Object.fromEntries(
                    (formData as any).entries()
                  );
                  formJson.filetype = filetype;
                  formJson.filekey = filekey;
                  formJson.exectype = "acceptUpload";
                  // formJson.sReview = "approve";
                  formJson.sReview = "Pre-Approved";
                  const fileResponse = await sendRequest(generalFileUrl, {
                    id: appId,
                    data: formJson,
                  });
                  if (fileResponse.code == 200) {
                    const fileUrl = fileResponse.filekey;
                    setFilePath(fileUrl);
                    setGenerateFileInfo({
                      filename:
                        fileResponse?.filename || fileResponse?.filekey || "",
                      filetype: fileResponse?.filetype || "",
                      filekey: fileResponse?.filekey || "",
                      filelink: fileResponse?.filelink || "",
                      docId: fileResponse?.docId || 0,
                    });
                    resetSubmitState();
                  } else {
                    errorNotify(
                      fileResponse?.message || "File generation failed!"
                    );
                  }
                  resetSubmitState();
                }
              } else {
                errorNotify(response?.message || "Data not saved!");
                resetSubmitState();
              }
            }
          },
        }}
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #e5e5e5",
            mb: 2,
          }}
        >
          <CustomApplicationDialogTitle
            record={record}
            subTitle={"Pre-Approved"}
          />
        </DialogTitle>

        <DialogContent>
          <DialogContentText></DialogContentText>
          <DialogApplicationBaseInfo appId={appId} record={record} />
          {filePath ? (
            <>
              <List
                sx={{
                  width: "100%",
                  maxWidth: "100%",
                  bgcolor: "background.paper",
                }}
              >
                <ListItem key={appId}>
                  <Link
                    sx={{
                      fontSize: "16px",
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    // onClick={handleDownloadPreApprovePDF}
                  >
                    Pre-Approve PDF
                    {/* {!showPreApproveDownloadIcon && (
                      <DownloadIcon
                        sx={{ fontSize: "20px", verticalAlign: "Bottom" }}
                      />
                    )}
                    {showPreApproveDownloadIcon && (
                      <CircularProgress
                        size={16}
                        color="inherit"
                        sx={{
                          marginLeft: "10px",
                          verticalAlign: "Bottom",
                        }}
                      />
                    )} */}
                    {generateFileInfo && generateFileInfo.filekey && (
                      <DownloadFieldLink
                        key={`doc_link_${appId}_${generateFileInfo.docId}_${
                          generateFileInfo?.filename || "na"
                        }_${String(generateFileInfo?.filelink || "na")}`}
                        // filename={appId + "_" + generateFileInfo?.filename}
                        filename={appId + "_Pre-Approve PDF"}
                        filelink={generateFileInfo?.filelink}
                      />
                    )}
                  </Link>
                </ListItem>
                <ListItem key="text-body">
                  <Typography variant="body2" color="text.secondary">
                    Click 'Send' Button, Application {appId} status will move to
                    Pre-Approved. To review this application, please select
                    "Pre-Approved" in the drop down menu.
                  </Typography>
                </ListItem>
              </List>
            </>
          ) : (
            <Box sx={{ width: "100%", height: "800px" }}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                >
                  {/* {disabledTab ? "disabled" : "active"}---- */}
                  <Tab
                    label="Pre-Approved"
                    {...a11yProps(0)}
                    disabled={disabledTab}
                  />
                  {termsDefineApprove?.includes("disbursement") && (
                    <Tab
                      label="Disbursement"
                      {...a11yProps(1)}
                      disabled={disabledTab}
                    />
                  )}
                  {(record?.bank_user_deposit_account_info
                    ?.sOrganizationType === "Bank" ||
                    record?.bank_user_deposit_account_info
                      ?.sOrganizationType === "Credit Union") && (
                    <Tab
                      label="Account"
                      {...a11yProps(2)}
                      disabled={disabledTab}
                    />
                  )}
                </Tabs>
              </Box>

              {/* start Pre-Approved Form */}
              <CustomTabPanel
                value={value}
                index={0}
                sx={{ "& input[readonly]": { backgroundColor: "#f5f5f5" } }}
              >
                <Grid
                  container
                  sx={{
                    position: "sticky",
                    top: "25px",
                    zIndex: 2,
                    justifyContent: "flex-end",
                    // backgroundColor: "#fff",
                    pb: 1,
                  }}
                >
                  <Grid item>
                    <CustomButtonSave
                      label={"Save"}
                      endIcon={
                        saveGeneralInfoTitle == "loading" ? (
                          <CircularProgress size={16} color="inherit" />
                        ) : null
                      }
                      variant="text"
                      size="medium"
                      color="primary"
                      sx={{ width: "120px" }}
                      onClick={(event: any) =>
                        handleSaveInfoPreApprove({ event, appId })
                      }
                      disabled={saveGeneralInfoTitle == "loading"}
                    />
                  </Grid>
                </Grid>
                <Grid container sx={{ mb: 2, pb: 2 }}>
                  {/* Loan Number */}
                  <Grid sx={{ mb: 2 }} container>
                    <Grid item xs={5} sx={{ pt: 1 }}>
                      <HeaderLabelTitle title="Loan Number" required />
                    </Grid>
                    <Grid item xs={5}>
                      <CustomControlEditTextField
                        name="loannum"
                        defaultValue={record.sLoanNum}
                        onChange={handleInputChange}
                        required={true}
                        helperText="no"
                      />
                    </Grid>
                    <Grid item xs={2}></Grid>
                  </Grid>
                  {/* loan amount */}
                  <Grid sx={{ mb: 2 }} container>
                    <Grid item xs={5} sx={{ pt: 1 }}>
                      <HeaderLabelTitle title="Loan Amount" required />
                    </Grid>

                    <Grid item xs={5}>
                      <CustomControlMoneyEditTextField
                        name="loanamount"
                        defaultValue={record.amountReview}
                        readonly={true}
                        onChange={handleInputChange}
                        required={true}
                        prefix={false}
                        helperText="no"
                      />
                    </Grid>
                    <Grid item xs={2}></Grid>
                  </Grid>
                  <Grid sx={{ mb: 2 }} container>
                    <Grid item xs={5} sx={{ pt: 1 }}>
                      <HeaderLabelTitle title="Interest Rate" required />
                    </Grid>
                    <Grid item xs={5}>
                      <CustomEditControlSelect
                        variant="outlined"
                        id="interest_rate"
                        name="interest_rate"
                        optionlist={defautRateOptionList}
                        value={interestRate == "0.00" ? 0 : interestRate}
                        required={true}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          if (e.target.value != undefined) {
                            setInterestRate(e.target.value.toString());
                          } else {
                            setInterestRate(0);
                          }
                          handleInputChange(e);
                        }}
                        helperText="no"
                      />
                    </Grid>
                    <Grid item xs={2}></Grid>
                  </Grid>

                  <Grid sx={{ mb: 2 }} container>
                    <Grid item xs={5} sx={{ pt: 1 }}>
                      <HeaderLabelTitle title="Term (Months)" required />
                    </Grid>
                    <Grid item xs={5}>
                      <CustomEditControlSelect
                        variant="outlined"
                        id="terms"
                        name="terms"
                        optionlist={defautTermsList}
                        value={terms}
                        required={true}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          if (e.target.value != undefined) {
                            setTerms(parseInt(e.target.value));
                          } else {
                            setTerms(0);
                          }
                          handleInputChange(e);
                        }}
                        helperText="no"
                      />
                    </Grid>
                    <Grid item xs={2}></Grid>
                  </Grid>

                  <Grid sx={{ mb: 2 }} container>
                    <Grid item xs={5} sx={{ pt: 1 }}>
                      <HeaderLabelTitle
                        title="Estimated Note Date (Funding Date)"
                        required
                      />
                    </Grid>
                    <Grid item xs={5}>
                      <CustomDateTextInput
                        id="note_date"
                        name="note_date"
                        value={noteDate ? noteDate : "today"}
                        required={true}
                        onChange={(value: any) => {
                          setNoteDate(value);
                        }}
                      />
                    </Grid>
                    <Grid item xs={2}></Grid>
                  </Grid>

                  <Grid sx={{ mb: 2 }} container>
                    <Grid item xs={5} sx={{ pt: 1 }}>
                      <HeaderLabelTitle
                        title="Estimated First Payment Date"
                        required
                      />
                    </Grid>
                    <Grid item xs={5}>
                      <CustomDateTextInput
                        id="first_payment_date"
                        name="first_payment_date"
                        value={firstPaymentDate}
                        required={true}
                        onChange={(value: any) => {
                          setFirstPaymentDate(value);
                        }}
                      />
                    </Grid>
                    <Grid item xs={2}></Grid>
                  </Grid>

                  <Grid sx={{ mb: 2 }} container>
                    <Grid item xs={5} sx={{ pt: 1 }}>
                      <HeaderLabelTitle title="Payment Frequency" required />
                    </Grid>
                    <Grid item xs={5}>
                      <CustomSelect
                        fullWidth={true}
                        id="payment_frequency"
                        name="payment_frequency"
                        value={paymentFrequency}
                        optionlist={defautPaymentFreqList}
                        required={true}
                        variant="outlined"
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          if (e.target.value != "") {
                            setPaymentFrequency(e.target.value);
                          }
                          handleInputChange(e);
                        }}
                      />
                    </Grid>
                    <Grid item xs={2}></Grid>
                  </Grid>

                  <Grid sx={{ mb: 2 }} container>
                    <Grid item xs={5} sx={{ pt: 1 }}>
                      <HeaderLabelTitle
                        fullWidth
                        title="Number Of Payments"
                        required
                      />
                    </Grid>
                    <Grid item xs={5}>
                      <TextField
                        fullWidth
                        type="text"
                        variant="outlined"
                        id="number_payments"
                        name="number_payments"
                        required={true}
                        value={paymentCount}
                        sx={{ "& input": { pl: "14px" } }}
                        onChange={(e) => {
                          handleInputChange(e);
                        }}
                      />
                    </Grid>
                    <Grid item xs={2}></Grid>
                  </Grid>

                  <Grid sx={{ mb: 2 }} container>
                    <Grid item xs={5} sx={{ pt: 1 }}>
                      <HeaderLabelTitle title="Maturity Date" required />
                    </Grid>
                    <Grid item xs={5}>
                      <TextField
                        fullWidth
                        type="text"
                        variant="outlined"
                        id="maturity_date"
                        name="maturity_date"
                        required={true}
                        value={maturityDate}
                        InputProps={{ readOnly: true }}
                        sx={{
                          background: "#e5e5e5",
                          "& input": { pl: "14px", pt: "5px" },
                        }}
                        onChange={(e) => {
                          handleInputChange(e);
                        }}
                      />
                    </Grid>
                    <Grid item xs={2}></Grid>
                  </Grid>

                  {/* Grace Period (Days) textField */}
                  <Grid sx={{ mb: 2 }} container>
                    <Grid item xs={5} sx={{ pt: 1 }}>
                      <HeaderLabelTitle title="Grace Period (Days)" />
                    </Grid>
                    <Grid item xs={5}>
                      <TextField
                        id="grace_period"
                        name="grace_period"
                        value={gracePeriodDay}
                        variant="outlined"
                        InputProps={{ readOnly: true }}
                        sx={{
                          background: "#e5e5e5",
                          "& input": { pl: "14px", pt: "5px" },
                        }}
                        onChange={(e) => {
                          handleInputChange(e);
                        }}
                      />
                    </Grid>
                    <Grid item xs={2}></Grid>
                  </Grid>
                  {/* late_fee textField */}
                  <Grid sx={{ mb: 2 }} container>
                    <Grid item xs={5} sx={{ pt: 1 }}>
                      <HeaderLabelTitle title="Late Fee" />
                    </Grid>
                    <Grid item xs={5}>
                      <CustomControlMoneyEditTextField
                        name="late_fee"
                        defaultValue={lateFee}
                        value={lateFee}
                        readonly={true}
                        onChange={handleInputChange}
                        required={false}
                        prefix={false}
                        helperText="no"
                      />
                    </Grid>
                    <Grid item xs={2}></Grid>
                  </Grid>
                  {/* origination_fee_amount , TextField  */}
                  <Grid sx={{ mb: 2 }} container>
                    <Grid item xs={5} sx={{ pt: 1 }}>
                      <HeaderLabelTitle title="Origination Fee Amount" />
                    </Grid>
                    <Grid item xs={5}>
                      <CustomControlMoneyEditTextField
                        name="origination_fee_amount"
                        value={originationFeeAmount}
                        readonly={true}
                        onChange={(e) => {
                          handleInputChange(e);
                          if (
                            e.target.value != "0" &&
                            e.target.value != "0.00" &&
                            e.target.value != ""
                          ) {
                            setOriginationFeeTypeRequired(true);
                          } else {
                            setOriginationFeeTypeRequired(false);
                          }
                        }}
                        required={false}
                        prefix={false}
                        helperText="no"
                      />
                    </Grid>
                    <Grid item xs={2}></Grid>
                  </Grid>
                  {/* origination_fee_type, select optionlist Add to Loan Amount:Add to Loan Amount, Deduct from Funded Amount: Deduct from Funded Amount */}
                  <Grid sx={{ mb: 2 }} container>
                    <Grid item xs={5} sx={{ pt: 1 }}>
                      <HeaderLabelTitle
                        title="Origination Fee Type"
                        required={!!originationFeeTypeRequired}
                      />
                    </Grid>
                    <Grid item xs={5}>
                      <CustomSelect
                        fullWidth={true}
                        id="origination_fee_type"
                        name="origination_fee_type"
                        value={origination_fee_type}
                        optionlist={defautOriginationFeeTypeList}
                        variant="outlined"
                        required={!!originationFeeTypeRequired}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          if (e.target.value != undefined) {
                            setOrigination_fee_type(e.target.value);
                          }
                          handleInputChange(e);
                        }}
                      />
                    </Grid>
                    <Grid item xs={2}></Grid>
                  </Grid>
                </Grid>
              </CustomTabPanel>
              {/* end Pre-Approved Form */}
              {termsDefineApprove?.includes("disbursement") && (
                <CustomTabPanel value={value} index={1}>
                  {/* Disbursement Form */}
                  <CustomToNotifyDisbursementDialog {...props} />
                </CustomTabPanel>
              )}
              {(record?.bank_user_deposit_account_info?.sOrganizationType ===
                "Bank" ||
                record?.bank_user_deposit_account_info?.sOrganizationType ===
                  "Credit Union") && (
                <CustomTabPanel value={value} index={2}>
                  {/* Deposit Institution Only section */}
                  <CustomToNotifyDepositDialog {...props} />
                </CustomTabPanel>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          {filePath ? (
            <>
              <CustomButtonCancel onClick={handleClose} />
              <Button
                label="Send"
                variant="contained"
                size="medium"
                sx={{ width: "120px", float: "right" }}
                disabled={isSubmitting || isPreviewLoading}
                onClick={() => handleApproveSend({ appId })}
              />
            </>
          ) : (
            <>
              <CustomButtonCancel onClick={handleClose} />
              {!isPreviewLoading && (
                <Button
                  label={previewTitle}
                  variant="text"
                  endIcon={
                    isPreviewLoading ? (
                      <CircularProgress size={16} color="inherit" />
                    ) : null
                  }
                  size="medium"
                  color="warning"
                  sx={{ width: "120px" }}
                  onClick={(event) => handlePreviewPreApprove({ event, appId })}
                  disabled={isPreviewLoading || isSubmitting}
                />
              )}
              {isPreviewLoading && (
                <Box sx={{ width: "260px", ml: 1 }}>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ display: "block", mb: 0.5 }}
                  >
                    {previewProgressLabel}
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <LinearProgress
                      variant="determinate"
                      value={previewProgress}
                      sx={{
                        flex: 1,
                        height: 10,
                        borderRadius: 5,
                        backgroundColor: "#bbdefb",
                        "& .MuiLinearProgress-bar": {
                          backgroundColor: "#1976d2",
                        },
                      }}
                    />
                    <Typography
                      variant="caption"
                      sx={{ color: "#1565c0", minWidth: "40px" }}
                    >
                      {Math.round(previewProgress)}%
                    </Typography>
                  </Box>
                </Box>
              )}
              <CustomButtonSubmit
                label={submitTitle}
                disabled={isPreviewLoading || isSubmitting}
              />
            </>
          )}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
